import { useEffect, useRef, useState } from 'react';
import { postFromApi } from 'common/api/src/config';

export interface DocumentSummary {
  totalHT: number;
  totalRemise: number;
  totalHTFinal: number;
  totalVAT: number;
  totalTTC: number;
  vatPercentage: number;
}

export function useDocumentPreview(
  lineItems: any[],
  debounceMs = 300,
): DocumentSummary | null {
  const [summary, setSummary] = useState<DocumentSummary | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    clearTimeout(timerRef.current);
    setSummary(null);

    const validItems = lineItems?.filter(
      (item) => item && (item.totalHT || item.unitPriceHT || item.priceHT),
    );

    if (!validItems?.length) {
      setSummary(null);
      return;
    }

    timerRef.current = setTimeout(async () => {
      try {
        const data = await postFromApi<{ lineItems: any[] }>('/preview/summary', {
          lineItems: validItems,
        });
        setSummary(data);
      } catch {}
    }, debounceMs);

    return () => clearTimeout(timerRef.current);
  }, [lineItems, debounceMs]);

  return summary;
}
